import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useCreateOutletMutation, useOutletsQuery, useUpdateOutletMutation, useStatusChangeMutation, useDeleteOutletMutation } from '../../../Store/Apis/outletApi'
import Loader from '../../../Components/Loader/Loader'
import Error from '../../../Components/Error/Error'
import AddEditOutletForm from '../../../Components/AddEditOutletForm/AddEditOutletForm'
import toast from 'react-hot-toast'
import { Table } from 'antd'
import { Modal } from 'react-bootstrap'
import { SearchOutlined, DownOutlined } from '@ant-design/icons';

const Outlets = () => {
  const otletsApi = useOutletsQuery()
  
  const [searchText, setSearchText] = useState('');
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    if (otletsApi?.data?.data) {
      setFilteredData(otletsApi?.data?.data);
    }
  }, [otletsApi]);

  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = otletsApi?.data?.data.filter((item) => {
      return (
        item.outletName.toLowerCase().includes(value.toLowerCase()) ||
        item.outletAddress.toLowerCase().includes(value.toLowerCase()) ||
        item.serviceCategoryName.toLowerCase().includes(value.toLowerCase())
      );
    });
    setFilteredData(filtered);
  };

  const columns = [
    {
      title: 'Outlet Name',
      dataIndex: 'outletName',
      key: 'outletName',
      sorter: (a, b) => a.outletName.localeCompare(b.outletName),
      filter: (value, record) => record.outletName.toLowerCase().includes(value.toLowerCase()),
      filterIcon: <SearchOutlined />,
      onFilter: (value, record) => record.outletName.toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: 'Logo',
      dataIndex: 'logo',
      key: 'logo',
      render: (i, action) => <img src={action.logo} alt="" height={50} />,
    },
    {
      title: 'Address',
      dataIndex: 'outletAddress',
      key: 'address',
      sorter: (a, b) => a.outletAddress.localeCompare(b.outletAddress),
      filter: (value, record) => record.outletAddress.toLowerCase().includes(value.toLowerCase()),
      filterIcon: <SearchOutlined />,
      onFilter: (value, record) => record.outletAddress.toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: 'Category',
      dataIndex: 'serviceCategoryName',
      key: 'category',
      sorter: (a, b) => a.serviceCategoryName.localeCompare(b.serviceCategoryName),
      filter: (value, record) => record.serviceCategoryName.toLowerCase().includes(value.toLowerCase()),
      filterIcon: <SearchOutlined />,
      onFilter: (value, record) => record.serviceCategoryName.toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (i, action) => (
        <button 
          type='button' 
          className={`btn badge badge-xs ${action.isActive == 1 ? 'badge-success': 'badge-danger'} fw-600 text-xs mb-0`} 
          onClick={() => setSelectedStatus(action)}
        >
            {action.isActive == 1 ? 'Active': 'Deactivated'}
        </button>
      ),
    },
    {
      title: 'Actions',
      dataIndex: 'actions',
      key: 'actions',
      render: (i, action) => (
        <>
          <button className="btn badge badge-xs badge-warning fw-600 text-xs mb-0" onClick={() => setSelectedEditRecord(action)}>
            View & Edit
          </button>
          <button 
            className="btn badge badge-xs badge-danger fw-600 text-xs mb-0 mx-2"
            onClick={()=>setSelectedDeleteRecord(action)}  
          >Delete</button>
        </>
      ),
    },
  ];


  // VIEW AND EDIT OUTLET
  const [updateOutlet, updateOutletResponse] = useUpdateOutletMutation()
  const [selectedEditRecord, setSelectedEditRecord] = useState(null);

  const handleSubmit = (outlet) => {
    const outletBody = {
      id: outlet.outletId,
      outletCode: outlet.outletCode,
      outletName: outlet.outletName,
      workstationId: 0,
      outletAddress: outlet.outletAddress,
      outletPhone: outlet.outletPhone,
      outletEmail: outlet.outletEmail,
      outletLatitude: outlet.latitude,
      outletLongitude: outlet.longitude,
      googleMap: "string",
      googleReviews: "string",
      qrCode: "string",
      logo: outlet.outletLogoString,
      checkinCheckout: false,
      isActive: outlet.isActive == 1 ? true : false,
      serviceCategoryID: Number(outlet.serviceCategoryID)
    }

    // You can send this role to the API or handle it accordingly
    updateOutlet(outletBody).then((res)=>{
      console.log(res)
      if(res.error){
        alert(JSON.stringify(res.error))
      } else {
        console.log('UPDATE OUTLET BODY ')
        setSelectedEditRecord(null)
      }
    })  
  };
  
  // ADD OUTLET
  const [addModalShow, setAddModalShow] = useState(false);
  const AddOutlet = ({addModalShow}) => {
    const [createOutlet, createOutletResponse] = useCreateOutletMutation()
    const handleCreateOutletSubmit = (outlet) => {
      console.log('Role Submitted:', outlet);
      const outletBody = {
        outletCode: outlet.outletCode,
        outletName: outlet.outletName,
        workstationId: 0,
        outletAddress: outlet.outletAddress,
        outletPhone: outlet.outletPhone,
        outletEmail: outlet.outletEmail,
        outletLatitude: outlet.latitude,
        outletLongitude: outlet.longitude,
        googleMap: "string",
        googleReviews: "string",
        qrCode: "string",
        logo: outlet.outletLogoString,
        checkinCheckout: 0,
        isActive: 1,
        serviceCategoryID: outlet.serviceCategoryID
      }
      createOutlet(outletBody).then((res)=>{
        if(res.error){
          alert(JSON.stringify(res.error))
        } 
        
        if(res.data.status === 200) {
          setAddModalShow(null)
          toast.success(res?.data?.message, { duration: 7000 });
        }
        
      })
    };

    return(
      <Modal show={addModalShow} onHide={()=>setAddModalShow(false)} size='lg' centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Outlet</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddEditOutletForm onSubmit={handleCreateOutletSubmit}/>
        </Modal.Body>
      </Modal>
    )
  }

  // STATUS CHANGE
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [changeStatus] = useStatusChangeMutation()
  const handleChangeStatus = () => {
    console.log(selectedStatus)
    changeStatus({
      keyID: selectedStatus.outletId,
      isActive: selectedStatus.isActive == 1 ? 0 : 1
    }).then((res)=>{
      console.log(res)
      setSelectedStatus(null)
    })
  }

  // DELETE
  const [selectedDeleteRecord, setSelectedDeleteRecord] = useState(null);
  const [deleteOutlet] = useDeleteOutletMutation()
  const handleDelete = () => {
    deleteOutlet(selectedDeleteRecord.outletId).then((res)=>{
      console.log(res)
      setSelectedDeleteRecord(null)
    })
  }


  return (
    <div>
      <div class="row align-items-center justify-content-between mb-4">
        <div class="col">
          <h5 class="fw-500 text-white">Outlets</h5>
        </div>
        <div class="col-auto">
          <Link onClick={() => setAddModalShow(true)} class="btn btn-icon btn-3 btn-white text-primary mb-0">
            <i class="fa fa-plus me-2"></i> Add New Outlet
          </Link>
          <AddOutlet addModalShow={addModalShow} />
        </div>
      </div>
      <div className="card">
        <div className="card-header p-4">
          <div className="row">
            <div className="col-md-12">
              <input
                type="text"
                className="form-control"
                placeholder="Search by Outlet Name and Category"
                onChange={(event)=>handleSearch(event.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="card-body p-0">
          {otletsApi.isError && <Error/>}
          {otletsApi.isLoading && <Loader height="500px"/>}
          {
            otletsApi.isSuccess && (
              <div className="table-responsive">
                  <Table 
                    columns={columns} 
                    dataSource={filteredData}
                  />
              </div>
            )
          }         
        </div>
      </div>


      {/* VIEW AND EDIT OUTLET  */}
      <Modal
        show={selectedEditRecord} onHide={()=>setSelectedEditRecord(false)}
      >
        <Modal.Header>View & Edit Outlet</Modal.Header>
        <Modal.Body>
          {selectedEditRecord && (
            <AddEditOutletForm onSubmit={handleSubmit} outletName={selectedEditRecord.outletId} />
          )}
        </Modal.Body>
      </Modal>

      {/* STATUS CHANGE MODAL */}
      <Modal 
          show={selectedStatus} 
          onHide={() => setSelectedStatus(null)} 
          size="sm" 
          centered
      >
          <Modal.Body className='text-center p-4'>
              <h5>Are you sure you want to change status?</h5>
              <div className="buttons d-flex gap-3 justify-content-center">
                  <button className='btn btn-danger bg-danger btn-sm mb-0' onClick={()=>(setSelectedStatus(null))}>Cancel</button>
                  <button className='btn btn-primary btn-sm mb-0' onClick={handleChangeStatus}>Confirm</button>
              </div>
          </Modal.Body>
      </Modal>

      {/* DELETE MODAL */}
      <Modal  
          show={selectedDeleteRecord} 
          onHide={() => setSelectedDeleteRecord(null)} 
          size="sm" 
          centered
      >
          <Modal.Body className='text-center p-4'>
              <h5>Are you sure you want to delete the outlet?</h5>
              <div className="buttons d-flex gap-3 justify-content-center">
                  <button className='btn btn-danger bg-danger btn-sm mb-0' onClick={()=>(setSelectedDeleteRecord(null))}>Cancel</button>
                  <button className='btn btn-primary btn-sm mb-0' onClick={handleDelete}>Confirm</button>
              </div>
          </Modal.Body>
      </Modal>
    </div>
  )
}

export default Outlets